import script from "./TimelineBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimelineBase.vue?vue&type=script&setup=true&lang=ts"

import "./TimelineBase.vue?vue&type=style&index=0&id=2939f702&lang=css"

const __exports__ = script;

export default __exports__
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QList from 'quasar/src/components/item/QList.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTimeline,QItem,QList,QCard});
